export default "__VITE_ASSET__4ae293ad__"